export const BREAKPOINT = '800px';

export const TAGLINE = 'knots to Beaufort plus more';

export const FONT_FAMILY = 'Helvetica, sans-serif, Arial';
